export default __webpack_public_path__ + "static/brand-18-0f81da474060f6581b5a732d1d2d0c88.png";